import { isValidEmailAddress, fadeOutNotifications } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const offersForm = {
        isLoading: false,
        init() {
            $(document).on('click', '.offer-show-form-btn', this, this.showForm);
            $(document).on('click', '.submit-offer-form', this, this.send);
        },
		showForm(event) {
			const _this = event.data;

			$('.offer-show-form-btn-wrapper').hide();
			$('.offer-form-container').show();
		},
		send(event) {
			const _this = event.data;
			event.preventDefault();

			let offerId = 1*$(this).data('id');

			if (_this.isLoading) {
                return false;
            }

			let errors = false;
			$('.offer-form-container').find('.form-control').removeClass('is-invalid');
			$('.offer-form-container').find('.form-check-input').removeClass('is-invalid');
			$('.offer-form-msgs-holder').hide();

			if ($('#offer_company_' + offerId).val() == '') {
				$('#offer_company_' + offerId).addClass('is-invalid');
				errors = true;
			}
			if ($('#offer_cui_' + offerId).val() == '') {
				$('#offer_cui_' + offerId).addClass('is-invalid');
				errors = true;
			}
			if ($('#offer_first_name_' + offerId).val() == '') {
				$('#offer_first_name_' + offerId).addClass('is-invalid');
				errors = true;
			}
			if ($('#offer_phone_' + offerId).val() == '') {
				$('#offer_phone_' + offerId).addClass('is-invalid');
				errors = true;
			}
			if ($('#offer_email_' + offerId).val() == '') {
				$('#offer_email_' + offerId).addClass('is-invalid');
				errors = true;
			}
			if ($('#offer_message_' + offerId).val() == '') {
				$('#offer_message_' + offerId).addClass('is-invalid');
				errors = true;
			}
			if (!$('#terms_and_conditions_' + offerId).is(":checked")) {
				$('#terms_and_conditions_' + offerId).addClass('is-invalid');
				errors = true;
			}

			if (errors) {
				$('#contact-form-error-msg').html('Va rugam completati toate campurile!').show();
				return false;
			}

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values = 'id=' + offerId;
			values += '&company=' + $('#offer_company_' +offerId).val();
			values += '&cui=' + $('#offer_cui_' +offerId).val();
			values += '&first_name=' + $('#offer_first_name_' +offerId).val();
			values += '&phone=' + $('#offer_phone_' +offerId).val();
			values += '&email=' + $('#offer_email_' +offerId).val();
			values += '&city=' + $('#offer_city_' +offerId).val();
			values += '&message=' + $('#offer_message_' +offerId).val();
			values += '&_token=' + $('#_token_offer_form_' +offerId).val();
			$.ajax({
	            type: "POST",
	            url: baseURL + "/offer/send",
	            data: values,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#offer_' + errorKey + '_' + offerId).addClass('is-invalid');
                                //errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }
						$('#contact-form-error-msg').html('Va rugam completati toate campurile!');
						$('.offer-form-container').find('.form-check-input').removeClass('is-invalid');
                        return false;
                    }

					if (response.status == 1) {
						$('.offer-form-container').find('.form-control').val('');
						$('#terms_and_conditions_' + offerId).prop('checked', false);

						Swal.fire({
							icon: 'success',
							title: 'Success!',
							html: response.message
						});

						if (cookies_advertisement == 1) {
							//gtag('event', 'conversion', {'send_to': 'AW-732195211/z_5UCI7a8-cBEIvTkd0C'});
						}

						if (cookies_advertisement == 1 || cookies_social == 1) {
							//fbq('track', 'Lead');
						}

						return false;
					}

					$('#contact-form-error-msg').html(response.message);
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		}
    };

	if ( $('.offer-form-container').length ) {
        offersForm.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/offers.js